import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import * as moment from 'moment-timezone';
import { ReportService } from '../reports-service/report.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { getBrokersList, isDecimal } from 'src/app/utils/utils.common';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { S } from '@angular/cdk/keycodes';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-driver-score',
  templateUrl: './driver-score.component.html',
  styleUrls: ['./driver-score.component.css']
})
export class DriverScoreComponent implements OnInit, OnDestroy {
  user;
  timeZone;
  todayDate;
  scoreDetails;
  driversScore;
  isDropOffTime = false;
  viewScorewModalObj = false;
  score;
  search;
  selectedCorporateId = '';
  corporateUsers;
  preSpaceTypes = {};
  drivers = [];
  specificDrivers =[];
  selectedDriver = '';
  filteredDriversScore = [];
  filteredServiceAreas = [];
  selectedServiceArea = [];
  serviceAreaList = [];
  preServiceAreas = [];
  driverList = [];
  
  constructor(
    private reportService: ReportService,
    private csvService: CsvService,
    private sharedDataService: SharedDataService,
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private driverService : DriversService,
    private serviceAreas : ServiceAreasService
  ) { }

  ngOnInit() {
    this.getUser();
    this.getCorporateUsers();
    this.getSpaceTypes();
    this.getServiceAreas();
    this.getDrivers();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
          this.todayDate = [moment.tz(this.timeZone).startOf('day').toISOString(), moment.tz(this.timeZone).endOf('day').toISOString()];
        }
      });
  }

  getDrivers() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.drivers = data;
        this.getDriversScore();
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
      });
  }
    getServiceAreas() {
      this.serviceAreas.getServiceAreas({ status: 'active' })
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(
          (data) => {
            if (data) {
              this.serviceAreaList = data;
              this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
            }
          },
          (err) => {
            sweetAlert("Error", err, "error", "Ok");
          }
        );
    }
  getCorporateUsers() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateUsers = data;
        }
      });
  }

  getDriversScore() {
    this.scoreDetails = {};
    this.driversScore = [];

    const payload = {
      startDate: this.todayDate[0],
      endDate: this.todayDate[1],
      isDropOffTime: this.isDropOffTime,
      cooperate: this.selectedCorporateId
    };

    this.reportService
      .getDriversScore(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          this.scoreDetails = data[0];
          this.driversScore = this.scoreDetails.drivers;

          this.specificDrivers = this.drivers.filter(driver =>
            this.driversScore.some(score => score.driver.displayName === driver.displayName)
          );
          this.driverList = this.specificDrivers;
          console.log("T3", this.specificDrivers);

          this.filteredServiceAreas = this.serviceAreaList.filter(serviceArea =>
            this.specificDrivers.some(driver =>
              driver.serviceAreas.includes(serviceArea._id)
            )
          );
          console.log("T4", this.filteredServiceAreas);


          this.filteredDriversScore = [...this.driversScore];
          console.log("T1", this.filteredDriversScore);
        }
      });
  }


  onSelectDriver() {

    if (this.selectedDriver) {
      this.filteredDriversScore = this.driversScore.filter(
        score => score.driver._id === this.selectedDriver
      );
      console.log("T2", this.filteredDriversScore);

    } else {
      this.filteredDriversScore = [...this.driversScore];
    }
  }


  onSelectServiceArea() {
    if (this.selectedServiceArea) {
      const serviceAreaDrivers = this.driverList.filter(driver =>
        driver.serviceAreas && driver.serviceAreas.includes(this.selectedServiceArea)
      );

      this.specificDrivers = serviceAreaDrivers;

      this.filteredDriversScore = this.driversScore.filter(score =>
        serviceAreaDrivers.some(driver => driver._id === score.driver._id)
      );
    } else {
      this.specificDrivers = [...this.driverList];
      this.filteredDriversScore = [...this.driversScore];
    }
  }


  onDateChange(event) {
    this.todayDate = [event[0].toISOString(), event[1].endOf('day').toISOString()];
    this.getDriversScore();
  }

  downloadReport(dScores, type?) {
    const data = {
      date: moment(this.todayDate[0]).format("MM/DD/YYYY") + " - " + moment(this.todayDate[1]).format("MM/DD/YYYY"),
      scores: type === 'all' ? dScores : [dScores]
    };
    this.csvService.generateScoreReport(data);
  }

  isDecimal(number) {
    return isDecimal(number);
  }

  toggleDropOffTime(){
    this.isDropOffTime = !this.isDropOffTime;
    this.getDriversScore();
  }

  viewScore(score){
    this.score = score;
    this.viewScorewModalObj = true;
  }

  close(){
    this.viewScorewModalObj = false;
  }

  brokerList(key?) {
    if (key) {
      return getBrokersList[key];
    }
    return getBrokersList;
  }

  onSelectCorporateUser(){
    this.getDriversScore();
  }

  ngOnDestroy(): void {
  }
}
